import React from 'react'
import ServiceItem from './ServiceItem'
import "../App.css"
function ServiceBox() {
    return (
        <>
        <section className='service-container'>

            <div className='container py-3 ' id='service'>
                <div className="row justify-content-center px-2 ">
                        <ServiceItem title=" Learn Online Courses " desc="Build ond polish your skills with courses and certificates. " btnText=" View all courses " route="onlineCourses" icon={<ion-icon name="laptop-outline"></ion-icon> } />
                        <ServiceItem title=" Global consultancy " desc=" Meet global Mentors and get carrier guidance." btnText=" View all consultancy " route="globalConsultancy" icon={<ion-icon name="earth-outline" ></ion-icon>} />
                        <ServiceItem title="Tution Classes " desc="Tutione classes to learning school subjects in online mode. " btnText="View all classes " icon={<ion-icon name="caret-forward-circle-outline"></ion-icon>} />
                </div>

                <div className="row justify-content-center px-2">
                        <ServiceItem title="International Projects " desc="Build your International experience by doing global projects. " btnText="View all classes " route="internationalProjects" icon={<ion-icon name="document-attach-outline"></ion-icon>} />
                        <ServiceItem title="Enterprises/NGO " desc="Manage and organize your Start-ups/Enterprises/NGO events with DOTS. " btnText="View all Startups " route="internationalProjects" icon={<ion-icon name="business-outline"></ion-icon>} />
                        <ServiceItem title="Checkout Events " desc="Organize your events at DOTS platform in just few clicks. " btnText="view all events " icon={<ion-icon name="calendar-clear-outline"></ion-icon>} />
                     
                </div>

                <div className="row justify-content-center px-2">
                        <ServiceItem title=" Coaching Institutes " desc="Promote your coaching institutes to offers collection of edutaining programmes  " btnText=" View all institutes " icon={<ion-icon name="home-outline"></ion-icon>} />
                        <ServiceItem title=" Study in best Schools " desc="Find the best school with wonderful facilities " btnText="View all school  " icon={<ion-icon name="school-outline"></ion-icon>} />
                        <ServiceItem title="Universities/Collages " desc="Search your desire universities/Collages around the Globe. " btnText="View all university " icon={<ion-icon name="flash-outline"></ion-icon>} />
                     
                </div>

            </div>
            </section>
        </>
    )
}

export default ServiceBox
